import {
  SHOPIFY_SESSION_REFERRER_ALL_SUCCESS,
  SHOPIFY_SESSION_REFERRER_ALL_LOADING,
  } from '../actions/SessionByReferrerAllAction';
  
  const initialState = {
    SessionByReffererAllData: [],
    isAllLoading: true
  };
  
  const SessionByReferrerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case SHOPIFY_SESSION_REFERRER_ALL_SUCCESS:
        return { ...state, SessionByReffererAllData: action.data, isAllLoading: false };
      case SHOPIFY_SESSION_REFERRER_ALL_LOADING:
        return { ...state, isAllLoading: action.isAllLoading };
      default:
        return state;
    }
  };
  
  export default SessionByReferrerReducer;
  